import { render, staticRenderFns } from "./vStatus.vue?vue&type=template&id=dc4dbb22&scoped=true&"
import script from "./vStatus.vue?vue&type=script&lang=js&"
export * from "./vStatus.vue?vue&type=script&lang=js&"
import style0 from "./vStatus.vue?vue&type=style&index=0&id=dc4dbb22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4dbb22",
  null
  
)

export default component.exports